import { useMutation } from '@tanstack/react-query';

import type { PostLetterResult } from '../../api/post-approval-letter/postApprovalLetter.types';
import type {
  UsePostApprovalLetterParams,
  UsePostApprovalLetterResult,
  UsePostApprovalLetterVariables,
} from './usePostApprovalLetter.types';

import { postApprovalLetter } from '../../api/post-approval-letter/postApprovalLetter';

export function usePostApprovalLetter(
  params: UsePostApprovalLetterParams
): UsePostApprovalLetterResult {
  return useMutation<PostLetterResult, Error, UsePostApprovalLetterVariables>({
    mutationFn: (
      variables: UsePostApprovalLetterVariables
    ): Promise<PostLetterResult> =>
      postApprovalLetter({
        customerId: params.customerId,
        instructorId: variables.instructorId,
        caseId: variables.caseId,
        file: variables.file,
        signal: variables.signal,
      }),
  });
}
